import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
const SettingsCtx = createContext({});

export function AppProviders({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({});

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    reload();
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, [reload]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, reload, logout }}>
      <SettingsCtx.Provider value={{ settings, setSettings }}>{children}</SettingsCtx.Provider>
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useSettings = () => useContext(SettingsCtx);
